<template>
  <div>
    <div class="category-top-bar" ref="optionsTopBar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
          <template v-if="showNexusActions">
            <button
              type="button"
              class="btn btn-icon btn-info mar-rt-10"
              style="margin-bottom: 0;"
              @click.prevent="fetchNexusInvoiceStatus"
              :title="$t('nexus.invoiceStatus')"
            >
              <i class="ti-reload"></i>
              {{ $t('nexus.invoiceStatus') }}
            </button>
            <button
              type="button"
              class="btn btn-icon btn-purple mar-rt-10"
              style="margin-bottom: 0;"
              @click.prevent="fetchNexusInvoiceLogs"
              :title="$t('nexus.invoiceLog')"
            >
              <i class="ti-list"></i>
              {{ $t('nexus.invoiceLog') }}
            </button>
            <button
              type="button"
              class="btn btn-icon btn-warning mar-rt-10"
              style="margin-bottom: 0;"
              @click.prevent="markNexusInvoiceManual"
              :title="$t('nexus.invoiceSend')"
            >
              <i class="ti-export"></i>
              {{ $t('nexus.invoiceSend') }}
            </button>
          </template>
          <button
            type="submit"
            class="btn btn-icon btn-success mar-rt-10 save"
            style="margin-bottom: 0;"
            @click.prevent="validate"
            :title="$t('general.save')"
          >
            <img src="/static/img/icons/save.png" />
            {{ $t('general.save') }}
          </button>
        </p>
      </div>
    </div>

    <div class="row mar-to-15">
      <div class="col-md-6">
        <div class="card">
          <div class="card-content">
            <h5>{{ $t('invoice.supplierDetails') }}</h5>
            <div class="form-group">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocationId" :disabled="isEditMode">
                <option value="" disabled>Selectează locația</option>
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat} — Locații: ${group.locations.map(l => l.name).join(', ')}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.true_id"
                    :value="loc.true_id"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>

            <div class="invoice-address-section">
              <div class="row address-row">
                <div class="col-xs-6 col-md-4">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientCountry') }}</label>
                    <select class="form-control" v-model="invoiceCountryCode">
                      <option
                        v-for="country in romaniaCountryOptions"
                        :key="country.code"
                        :value="country.code"
                      >
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-6 col-md-4">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientCounty') }}</label>
                    <select class="form-control" v-model="invoiceCountyCode">
                      <option value="" disabled>{{ $t('invoice.selectCounty') }}</option>
                      <option
                        v-for="county in romanianCounties"
                        :key="county.code"
                        :value="county.code"
                      >
                        {{ county.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-6 col-md-4">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientCity') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="invoiceCity"
                      :placeholder="$t('invoice.clientCity')"
                    />
                  </div>
                </div>
              </div>
              <div class="row address-row">
                <div class="col-xs-12 col-md-8">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientStreet') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="invoiceStreet"
                      :placeholder="$t('invoice.clientStreet')"
                    />
                  </div>
                </div>
                <div class="col-xs-12 col-md-4">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientStreetNumber') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="invoiceStreetNumber"
                      :placeholder="$t('invoice.clientStreetNumber')"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label>{{ $t('invoice.vatPayer') }}</label>
                <select class="form-control" v-model="invoiceVATPayer" disabled>
                  <option value="yes">{{ $t('invoice.yes') }}</option>
                  <option value="no">{{ $t('invoice.no') }}</option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label>{{ $t('invoice.issueDate') }}</label>
              <input type="datetime-local" class="form-control" v-model="issueDate" :max="today"/>
            </div>

            <div class="form-group">
              <label>{{ $t('invoice.dueDate') }}</label>
              <input type="datetime-local" class="form-control" v-model="dueDate" :max="today"/>
            </div>

            <div class="form-group row">
              <div class="col-md-6">
                <label>{{ $t('invoice.series') }}*</label>
                <select class="form-control" v-model="seriesNumber" @change="updateNumber">
                  <option value="" disabled>{{ $t('invoice.selectSeries') }}</option>
                  <option
                    v-for="series in seriesOptionsWithAdd"
                    :key="series.id || series.series"
                    :value="series.id || series.series"
                  >
                    {{ series.nume || series.series }}
                  </option>
                </select>
              </div>

              <div class="col-md-6">
                <label>{{ $t('gestiune.currentNumber') }}</label>
                <input type="number" class="form-control" v-model="currentNumber" disabled />
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card">
          <div class="card-content">
            <h5>{{ $t('invoice.clientDetails') }}</h5>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.clientName') }}*</label>
                  <v-select
                    v-model="clientSelected"
                    :options="clientResults"
                    label="nume"
                    placeholder="Caută un client..."
                    :filterable="false"
                    :disabled="!selectedLocation"
                    @search="fetchClients"
                    @input="onClientSelect"
                  />
                  <div class="v-select-loader" v-if="loading"></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.clientCUI') }}*</label>
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('invoice.clientCUI')"
                    :value="clientCUI"
                    v-validate="modelValidate.clientCUI"
                    @input="clientCUI = $event.target.value"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.clientEmail') }}</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="clientEmail"
                    :placeholder="$t('invoice.clientEmail')"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('invoice.clientPhone') }}*</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="clientPhone"
                    v-validate="modelValidate.clientPhone"
                    :placeholder="$t('invoice.clientPhone')"
                  />
                </div>
              </div>
            </div>
            <div class="client-address-section">
              <label class="address-section-label">{{ $t('invoice.clientAddress') }}*</label>
              <div class="row address-row">
                <div class="col-xs-6 col-md-4">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientCountry') }}*</label>
                    <select class="form-control" v-model="clientCountryCode">
                      <option
                        v-for="country in romaniaCountryOptions"
                        :key="country.code"
                        :value="country.code"
                      >
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-6 col-md-4">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientCounty') }}*</label>
                    <select class="form-control" v-model="clientCountyCode">
                      <option value="" disabled>{{ $t('invoice.selectCounty') }}</option>
                      <option
                        v-for="county in romanianCounties"
                        :key="county.code"
                        :value="county.code"
                      >
                        {{ county.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-6 col-md-4">
                  <div class="form-group">
                    <label>{{ isClientBucharest ? $t('invoice.clientSector') : $t('invoice.clientCity') }}*</label>
                    <select
                      v-if="isClientBucharest"
                      class="form-control"
                      v-model="clientCity"
                    >
                      <option value="" disabled>{{ $t('invoice.selectSector') }}</option>
                      <option
                        v-for="sector in bucharestSectors"
                        :key="sector.code"
                        :value="sector.code"
                      >
                        {{ sector.name }}
                      </option>
                    </select>
                    <input
                      v-else
                      type="text"
                      class="form-control"
                      v-model="clientCity"
                      :placeholder="$t('invoice.clientCity')"
                    />
                  </div>
                </div>
              </div>
              <div class="row address-row">
                <div class="col-xs-12 col-md-5">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientStreet') }}*</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="clientStreet"
                      :placeholder="$t('invoice.clientStreet')"
                    />
                  </div>
                </div>
                <div class="col-xs-4 col-md-2">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientStreetNumber') }}*</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="clientStreetNumber"
                      :placeholder="$t('invoice.clientStreetNumber')"
                    />
                  </div>
                </div>
                <div class="col-xs-8 col-md-5">
                  <div class="form-group">
                    <label>{{ $t('invoice.clientPostalCode') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="clientPostalCode"
                      :placeholder="$t('invoice.clientPostalCode')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="box">
                <div class="title">
                  <p>{{ $t('gestiune.addProductInInvoice') }}</p>
                </div>
                <div v-if="!isInvoice" class="search">
                  <input
                    type="text"
                    v-model="searchTerm"
                    class="form-control"
                    placeholder="Search Order Id..."
                  />
                  <div class="btn btn-icon btn-search" :title="$t('reports.search')" @click="searchOrder"><i class="ti-search"></i></div>
                </div>
              </div>
              <div v-if="hasOrderInfo" class="order-info-summary">
                <div class="order-info-header">
                  <div class="order-info-header-icon">
                    <i class="ti-receipt"></i>
                  </div>
                  <div>
                    <p class="order-info-title">Informații comandă</p>
                    <p class="order-info-subtitle">Date preluate automat din comanda asociată</p>
                  </div>
                </div>
                <div class="order-info-grid">
                  <div class="order-info-card" v-if="orderDate">
                    <div class="order-info-card-icon">
                      <i class="ti-calendar"></i>
                    </div>
                    <div class="order-info-card-body">
                      <span class="order-info-label">Data comandă</span>
                      <span class="order-info-value">{{ orderDate }}</span>
                    </div>
                  </div>
                  <div class="order-info-card" v-if="orderNumber">
                    <div class="order-info-card-icon">
                      <i class="ti-shopping-cart-full"></i>
                    </div>
                    <div class="order-info-card-body">
                      <span class="order-info-label">Nr. comandă</span>
                      <span class="order-info-value">#{{ orderNumber }}</span>
                    </div>
                  </div>
                  <div class="order-info-card" v-if="bonData">
                    <div class="order-info-card-icon">
                      <i class="ti-time"></i>
                    </div>
                    <div class="order-info-card-body">
                      <span class="order-info-label">Data bon</span>
                      <span class="order-info-value">{{ bonData }}</span>
                    </div>
                  </div>
                  <div class="order-info-card order-info-card--highlight" v-if="bonNumber">
                    <div class="order-info-card-icon">
                      <i class="ti-ticket"></i>
                    </div>
                    <div class="order-info-card-body">
                      <span class="order-info-label">Bon fiscal</span>
                      <span class="order-info-value">{{ bonNumber }}</span>
                    </div>
                  </div>
                  <div class="order-info-card" v-if="paymentType">
                    <div class="order-info-card-icon">
                      <i class="ti-money"></i>
                    </div>
                    <div class="order-info-card-body">
                      <span class="order-info-label">Plată</span>
                      <span class="order-info-value">{{ formatPaymentTypeLabel(paymentType) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="sm" />
            </div>
          </div>
          <template>
            <div>
              <table class="table">
                <thead>
                  <tr>
                    <th>{{ $t('gestiune.gestiune') }}*</th>
                    <th>{{ $t('invoice.productName') }}*</th>
                    <th>{{ $t('invoice.type') }}*</th>
                    <th>{{ $t('gestiune.codeProduct') }}*</th>
                    <th>{{ $t('invoice.unitMeasure') }}*</th>
                    <th>{{ $t('invoice.quantity') }}*</th>
                    <th>{{ $t('invoice.vatRate') }}</th>
                    <th>{{ $t('gestiune.pretFaraTva') }}*</th>
                    <th>{{ $t('gestiune.valoare') }}</th>
                    <th>TVA</th>
                    <th v-if="!isDisabled && !isEdit">{{ $t('general.actions') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <td>{{ getGestiuneName(item.gestiuneFrom) }}</td>
                    <td>{{ typeof item.productName === 'object' ? item.productName.name : item.productName }}</td>
                    <td>{{ item.type }}</td>
                    <td>{{ item.code }}</td>
                    <td>{{ item.unitMeasure }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.vatRate }}%</td>
                    <td>{{ item.priceRON }}</td>
                    <td>{{ item.valoare }}</td>
                    <td>{{ item.tva }}</td>
                    <td v-if="!isDisabled && !isEdit">
                      <a class="btn btn-danger btn-icon delete mar-rt-10" @click="removeItem(index)" :disabled="isInvoice">
                          <img src="/static/img/icons/icon-close.png">
                          {{$t('general.delete')}}
                      </a>
                    </td>
                  </tr>
                  <tr v-if="!isEdit && !isStorno && !isInvoice && !isDisabled">
                    <td>
                      <select v-model="newItem.gestiuneId" class="form-control">
                        <option disabled :value="null">Selectează gestiunea</option>
                        <option
                          v-for="gestiune in filteredGestiuni"
                          :key="gestiune.id"
                          :value="gestiune.id"
                        >
                          {{ gestiune.name }}
                        </option>
                      </select>
                    </td>
                    <td style="width: 250px !important;">
                      <v-select
                        v-model="newItem.productName"
                        :options="searchResults"
                        label="name"
                        placeholder="Caută un produs..."
                        :filterable="false"
                        @search="fetchProducts"
                        @input="onProductSelected"
                      >
                        <template #no-options>
                          <span v-if="!loadingProducts">Niciun produs găsit</span>
                        </template>
                      </v-select>

                      <div class="v-select-loader" v-if="loadingProducts"></div>
                    </td>
                    <td>
                      <select v-model="newItem.type" class="form-control" :disabled="true">
                        <option value="">Tip</option>
                        <option value="Marfa">Marfa</option>
                        <option value="Materii prime">Materii prime</option>
                        <option value="Materiale consumabile">Materiale consumabile</option>
                        <option value="Semifabricate (Reteta)">Semifabricate (Reteta)</option>
                        <option value="Produs finit (Reteta)">Produs finit (Reteta)</option>
                        <option value="Produs rezidual">Produs rezidual</option>
                        <option value="Ambalaje">Ambalaje</option>
                        <option value="Obiecte de inventar">Obiecte de inventar</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        v-model="newItem.code"
                        :disabled="true"
                        placeholder="Cod"
                      />
                    </td>
                    <td>
                      <el-select
                        v-model="newItem.unitMeasure"
                        :disabled="true"
                        placeholder="Selectează unitatea de măsură"
                      >
                        <!-- <el-option
                          v-for="option in unitMeasureOptions"
                          :key="option"
                          :label="option"
                          :value="option"
                        ></el-option> -->
                      </el-select>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="newItem.quantity"
                        :placeholder="$t('invoice.quantity')"
                      />
                    </td>
                    <td>
                      <el-select
                        v-model="newItem.vatRate"
                        placeholder="Cota TVA"
                      >
                        <el-option
                          v-for="vat in vats"
                          :key="vat.tax_id"
                          :label="`${vat.amount} %`"
                          :value="vat.amount"
                        />
                      </el-select>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="newItem.priceRON"
                        :placeholder="$t('gestiune.pretFaraTva')"
                      />
                    </td>
                    <td>
                      <el-select
                        v-model="newItem.includeVAT"
                        placeholder="Prețul include TVA?"
                      >
                        <el-option label="Cu TVA" value="yes"></el-option>
                        <el-option label="Fără TVA" value="no"></el-option>
                      </el-select>
                    </td>
                    <td>
                      <input
                        type="number"
                        class="form-control"
                        disabled
                        v-model.number="newItem.tva"
                        :placeholder="$t('gestiune.tva')"
                      />
                    </td>
                    <td>
                      <button class="btn btn-primary" @click="addItem">
                        {{ $t('general.add') }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <div class="totals-container">
            <div class="total-row">
              <span class="label">Total fara TVA:</span>
              <span class="value">{{ totalFaraTva.toFixed(2) }} RON</span>
            </div>
            <div class="total-row">
              <span class="label">Total TVA:</span>
              <span class="value">{{ totalTva.toFixed(2) }} RON</span>
            </div>
            <div class="total-row" v-if="totalCorectie !== 0">
              <span class="label">Corectie Document:</span>
              <span class="value">{{ totalCorectie.toFixed(2) }} RON</span>
            </div>
            <div class="total-row total-final">
              <span class="label">Total:</span>
              <span class="value">{{ totalFinal.toFixed(2) }} RON</span>
            </div>
          </div>
        </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <h5>Informatii aditionale factura</h5>
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="intocmitDe">Întocmit de</label>
                  <input type="text" id="intocmitDe" class="form-control" placeholder="Numele persoanei" v-model="extraFields.intocmitDe" />
                </div>
                <div class="form-group">
                  <label for="cnp">CNP</label>
                  <input type="text" id="cnp" class="form-control" placeholder="Cod Numeric Personal" v-model="extraFields.cnp" />
                </div>
                <div class="form-group">
                  <label for="delegat">Delegat</label>
                  <input type="text" id="delegat" class="form-control" placeholder="Numele delegatului" v-model="extraFields.delegat" />
                </div>
                <div class="form-group">
                  <label for="carteIdentitate">Carte Identitate</label>
                  <input type="text" id="carteIdentitate" class="form-control" placeholder="Seria și numărul cărții de identitate" v-model="extraFields.carteIdentitate" />
                </div>
                <div class="form-group">
                  <label for="auto">Auto</label>
                  <input type="text" id="auto" class="form-control" placeholder="Marca și modelul auto" v-model="extraFields.auto" />
                </div>
                <div class="form-group">
                  <label for="agentVanzari">Agent vânzări</label>
                  <input type="text" id="agentVanzari" class="form-control" placeholder="Numele agentului de vânzări" v-model="extraFields.agentVanzari" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="punctDeLucruClient">Punct de Lucru Client</label>
                  <input type="text" id="punctDeLucruClient" class="form-control" placeholder="Locația punctului de lucru" v-model="extraFields.punctDeLucruClient" />
                </div>
                <div class="form-group">
                  <label for="numarComandaBT13">Număr comandă BT-13</label>
                  <input type="text" id="numarComandaBT13" class="form-control" placeholder="Numărul comenzii" v-model="extraFields.numarComandaBT13" />
                </div>
                <div class="form-group">
                  <label for="numarContractBT12">Număr contract BT-12</label>
                  <input type="text" id="numarContractBT12" class="form-control" placeholder="Numărul contractului" v-model="extraFields.numarContractBT12" />
                </div>
                <div class="form-group">
                  <label for="referintaProiectBT11">Referință proiect BT-11</label>
                  <input type="text" id="referintaProiectBT11" class="form-control" placeholder="Codul proiectului" v-model="extraFields.referintaProiectBT11" />
                </div>
                <div class="form-group">
                  <label for="identificatorCumparatorBT46">Identificator cumpărător BT-46</label>
                  <input type="text" id="identificatorCumparatorBT46" class="form-control" placeholder="ID-ul cumpărătorului" v-model="extraFields.identificatorCumparatorBT46" />
                </div>
                <div class="form-group">
                  <label for="numarAvizReceptieBT15">Număr aviz recepție BT-15</label>
                  <input type="text" id="numarAvizReceptieBT15" class="form-control" placeholder="Numărul avizului" v-model="extraFields.numarAvizReceptieBT15" />
                </div>
                <div class="form-group">
                  <label for="referintaContabilaCumparatorBT19">Referință contabilă cumpărător BT-19</label>
                  <input type="text" id="referintaContabilaCumparatorBT19" class="form-control" placeholder="Referința contabilă" v-model="extraFields.referintaContabilaCumparatorBT19" />
                </div>
                <div class="form-group">
                  <label for="dataLivrarii">Data livrării</label>
                  <input type="date" id="dataLivrarii" class="form-control" v-model="extraFields.dataLivrarii" />
                </div>
                <div class="form-group">
                  <label for="dataIncasarii">Data încasării</label>
                  <input type="date" id="dataIncasarii" class="form-control" v-model="extraFields.dataIncasarii" />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="bonNota">Observații bon / comandă</label>
              <textarea
                id="bonNota"
                class="form-control observatii-comanda-textarea"
                rows="4"
                v-model="bonNota"
                placeholder="Detalii comandă și bon fiscal..."
              ></textarea>
            </div>
            <div class="form-group">
              <label for="notaInterna">Notă internă</label>
              <textarea id="notaInterna" class="form-control" placeholder="Informații suplimentare" v-model="extraFields.notaInterna"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ManagementClientsAdd :groupedLocations="groupedLocations"/>

    <ManagementSeriesAdd
      :locations="locations"
      :grouped-locations="groupedLocations"
      :vat-number="selectedLocation ? selectedLocation.inv_fiscal_code : ''"
      @getSeries="getSeries"
    />
  </div>
</template>


  <script>
  import swal from 'sweetalert2'
  import ManagementClientsAdd from '../Management/Nomenclator/ManagementClientsAdd.vue'
  import ManagementSeriesAdd from '../Management/ManagementSeriesAdd.vue'

  const ROMANIA_COUNTRY_OPTIONS = [
    { code: 'RO', name: 'România' }
  ]

  const ROMANIAN_COUNTIES = [
    { code: 'AB', name: 'Alba' },
    { code: 'AR', name: 'Arad' },
    { code: 'AG', name: 'Argeș' },
    { code: 'BC', name: 'Bacău' },
    { code: 'BH', name: 'Bihor' },
    { code: 'BN', name: 'Bistrița-Năsăud' },
    { code: 'BT', name: 'Botoșani' },
    { code: 'BR', name: 'Brăila' },
    { code: 'BV', name: 'Brașov' },
    { code: 'B', name: 'București' },
    { code: 'BZ', name: 'Buzău' },
    { code: 'CS', name: 'Caraș-Severin' },
    { code: 'CL', name: 'Călărași' },
    { code: 'CJ', name: 'Cluj' },
    { code: 'CT', name: 'Constanța' },
    { code: 'CV', name: 'Covasna' },
    { code: 'DB', name: 'Dâmbovița' },
    { code: 'DJ', name: 'Dolj' },
    { code: 'GL', name: 'Galați' },
    { code: 'GR', name: 'Giurgiu' },
    { code: 'GJ', name: 'Gorj' },
    { code: 'HR', name: 'Harghita' },
    { code: 'HD', name: 'Hunedoara' },
    { code: 'IL', name: 'Ialomița' },
    { code: 'IS', name: 'Iași' },
    { code: 'IF', name: 'Ilfov' },
    { code: 'MM', name: 'Maramureș' },
    { code: 'MH', name: 'Mehedinți' },
    { code: 'MS', name: 'Mureș' },
    { code: 'NT', name: 'Neamț' },
    { code: 'OT', name: 'Olt' },
    { code: 'PH', name: 'Prahova' },
    { code: 'SM', name: 'Satu Mare' },
    { code: 'SJ', name: 'Sălaj' },
    { code: 'SB', name: 'Sibiu' },
    { code: 'SV', name: 'Suceava' },
    { code: 'TR', name: 'Teleorman' },
    { code: 'TM', name: 'Timiș' },
    { code: 'TL', name: 'Tulcea' },
    { code: 'VS', name: 'Vaslui' },
    { code: 'VL', name: 'Vâlcea' },
    { code: 'VN', name: 'Vrancea' }
  ]

  const BUCHAREST_SECTORS = [
    { code: 'SECTOR1', name: 'Sector 1' },
    { code: 'SECTOR2', name: 'Sector 2' },
    { code: 'SECTOR3', name: 'Sector 3' },
    { code: 'SECTOR4', name: 'Sector 4' },
    { code: 'SECTOR5', name: 'Sector 5' },
    { code: 'SECTOR6', name: 'Sector 6' }
  ]

  export default {
    components: {
      ManagementClientsAdd,
      ManagementSeriesAdd
    },
    data () {
      return {
        isInvoice: false,
        loading: false,
        loadingProducts: false,
        selectedLocationId: '',
        selectedLocation: null,
        romaniaCountryOptions: ROMANIA_COUNTRY_OPTIONS,
        romanianCounties: ROMANIAN_COUNTIES,
        bucharestSectors: BUCHAREST_SECTORS,
        invoiceCountryCode: 'RO',
        invoiceCountyCode: '',
        invoiceCity: '',
        invoiceStreet: '',
        invoiceStreetNumber: '',
        invoiceVATPayer: 'no',
        searchTerm: '',
        linkedOrderId: null,
        orderDate: '',
        orderNumber: '',
        bonData: '',
        bonNumber: '',
        bonNota: '',
        paymentType: '',
        currentNumber: '',
        clientName: '',
        clientCUI: '',
        clientEmail: '',
        clientPhone: '',
        clientCountryCode: 'RO',
        clientCountyCode: '',
        clientCity: '',
        clientStreet: '',
        clientStreetNumber: '',
        clientPostalCode: '',
        clientVATPayer: 'yes',
        clientLegalStatus: 'juridica_ro',
        issueDate: this.getLocalDateTimeString(),
        dueDate: this.getLocalDateTimeString(),
        seriesNumber: '',
        currency: 'RON',
        language: 'ro',
        productName: '',
        clientSelected: null,
        clientResults: [],
        quantity: 0,
        priceRON: 0,
        vatRate: 0,
        includeVAT: 'no',
        vatNumber: null,
        isDisabled: false,
        searchResults: [],
        items: [],
        isEdit: false,
        isStorno: false,
        gestiuneOptions: [],
        descarcaGestiunea: false,
        isEditMode: false,
        vats: [],
        newItem: {
          gestiuneId: null,
          productName: '',
          unitMeasure: 'buc',
          quantity: 1,
          priceRON: null,
          vatRate: '',
          includeVAT: 'no',
          type: '',
          code: ''
        },
        fetchClientsCalled: false,
        modelValidate: {
          clientCUI: { required: true },
          clientName: { required: true },
          productName: { required: true },
          unitMeasure: { required: true },
          clientPhone: { required: true },
          quantity: { required: true },
          priceRON: { required: true },
          vatRate: { required: true },
          includeVAT: { required: true }
        },
        locations: [],
        extraFields: {
          intocmitDe: '',
          cnp: '',
          delegat: '',
          carteIdentitate: '',
          auto: '',
          agentVanzari: '',
          punctDeLucruClient: '',
          numarComandaBT13: '',
          numarContractBT12: '',
          referintaProiectBT11: '',
          identificatorCumparatorBT46: '',
          numarAvizReceptieBT15: '',
          referintaContabilaCumparatorBT19: '',
          dataLivrarii: '',
          dataIncasarii: '',
          observatiiFactura: '',
          notaInterna: ''
        },
        seriesOptions: [],
        gestiuniList: [],
        apiClientKey: this.$session.get('selectedCompanyData')['api_client_key']
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      today () {
        const now = new Date()
        now.setSeconds(0, 0)
        return now.toISOString().slice(0, 16)
      },
      seriesOptionsWithAdd () {
        return [
          ...this.seriesOptions,
          { id: 'add', nume: '➕ Adaugă serie' }
        ]
      },
      totalTva () {
        return this.items.reduce((acc, item) => acc + (Number(item.tva) || 0), 0)
      },
      totalFaraTva () {
        return this.items.reduce((acc, item) => {
          const valoare = Number(item.valoare)
          const tva = Number(item.tva) || 0
          if (Number.isFinite(valoare)) {
            return acc + (valoare - tva)
          }

          const qty = Number(item.quantity) || 0
          const priceNoVAT = Number(item.priceRON) || 0
          return acc + priceNoVAT * qty
        }, 0)
      },
      totalCorectie () {
        return 0
      },
      totalFinal () {
        return this.totalFaraTva + this.totalTva + this.totalCorectie
      },
      groupedLocations () {
        const groups = {}

        if (!this.locations || !this.locations.length) return []

        this.locations.forEach(location => {
          const vat = location.inv_fiscal_code || 'Fără cod fiscal'
          if (!groups[vat]) {
            groups[vat] = []
          }
          groups[vat].push(location)
        })

        const result = Object.entries(groups).map(([vat, locations]) => ({
          vat,
          locations
        }))

        return result
      },
      filteredGestiuni () {
        if (!this.selectedLocationId) return []
        const result = this.gestiuneOptions.filter(
          (g) => g.externalLocationId === this.selectedLocationId
        )
        console.log('🚀 filteredGestiuni:', result)
        return result
      },
      hasOrderInfo () {
        return !!(this.orderDate || this.orderNumber || this.bonData || this.bonNumber)
      },
      isClientBucharest () {
        return this.clientCountyCode === 'B'
      },
      hasNexusLocation () {
        const defaultData = this.$session.get('defaultData') || {}
        return !!defaultData.has_nexus_location
      },
      nexusOrderId () {
        return String(this.orderNumber || this.searchTerm || '').trim()
      },
      showNexusActions () {
        return this.hasNexusLocation && !!this.nexusOrderId
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')
      const path = this.route.path

      const id = this.route && this.route.params && this.route.params.id
      if (id) {
        const parts = id.split('-')
        if (parts.length === 2) {
          this.series = parts[0]
          this.invoiceNumber = parts[1]

          this.isStorno = path.includes('storno')
          this.isEdit = path.includes('edit')
          this.isEditMode = this.isEdit

          if (this.isStorno) {
            this.issueDate = ''
            this.dueDate = ''
          }
        } else {
          console.error('Invalid invoice ID format:', id)
        }
      }

      this.fetchGestiuni()
      this.fetchLocation()
    },
    watch: {
      selectedLocationId (id) {
        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedLocation = loc
            if (!this.isEditMode && !this.isStorno && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code)

              this.loadVats(loc.true_id)
            }

            if (!this.isEditMode && !this.isStorno) {
              this.applySupplierDetailsFromLocation(loc)
              this.syncBonNotaField()
            }

            break
          }
        }
      },
      locations (newLocations) {
        if (newLocations && newLocations.length) {
          const { series, number, isInvoice } = this.route.query
          this.isInvoice = (isInvoice === 'true' || isInvoice === true)

          if (this.isInvoice) {
            this.fetchOrder(series, number)
          }

          const invoiceId = this.route && this.route.params && this.route.params.id
          if (invoiceId) {
            this.getInvoiceDetails(invoiceId)
          }
        }
      },
      clientCountyCode (newCode, oldCode) {
        if (newCode === oldCode) return

        if (newCode === 'B') {
          const normalized = this.normalizeBucharestSector(this.clientCity)
          this.clientCity = this.isValidBucharestSector(normalized) ? normalized : ''
          return
        }

        if (oldCode === 'B' && this.isValidBucharestSector(this.clientCity)) {
          this.clientCity = ''
        }
      },
      clientCUI (newCUI) {
        if ((this.isEdit || this.isStorno || this.isInvoice)) {
          return
        }

        if (this.fetchClientsCalled) return

        if (newCUI.length >= 8) {
          this.fetchCompanyDetails(newCUI)
        }
      }
    },
    methods: {
      getInvoiceValidationErrors () {
        const errors = []

        if (!this.selectedLocationId || !this.selectedLocation) {
          errors.push('Locația')
        }
        if (!this.seriesNumber) {
          errors.push('Seria facturii')
        }
        if (this.isStorno && !this.issueDate) {
          errors.push('Data Emiterii')
        }
        if (this.isStorno && !this.dueDate) {
          errors.push('Termen de Plată')
        }
        if (!this.currency) {
          errors.push('Moneda')
        }
        if (!String(this.clientName || '').trim()) {
          errors.push('Numele clientului')
        }
        if (!String(this.clientCUI || '').trim()) {
          errors.push('CUI/CNP client')
        }
        if (!String(this.clientPhone || '').trim()) {
          errors.push('Telefon client')
        }
        if (!this.clientCountyCode) {
          errors.push('Județ client')
        }
        if (!String(this.clientCity || '').trim()) {
          errors.push(this.isClientBucharest ? 'Sector client' : 'Oraș client')
        } else if (this.isClientBucharest && !this.isValidBucharestSector(this.clientCity)) {
          errors.push('Sector client')
        }
        if (!String(this.clientStreet || '').trim()) {
          errors.push('Strada client')
        }
        if (!String(this.clientStreetNumber || '').trim()) {
          errors.push('Număr stradă client')
        }
        if (!this.items || !this.items.length) {
          errors.push('Cel puțin un produs')
        }

        return errors
      },
      showInvoiceValidationErrors (errors) {
        const text = errors.length === 1
          ? `Completați câmpul obligatoriu: ${errors[0]}.`
          : `Completați câmpurile obligatorii: ${errors.join(', ')}.`

        swal({
          title: 'Eroare',
          text,
          type: 'error',
          timer: errors.length > 1 ? 4500 : 2500,
          showConfirmButton: false
        })
      },
      validate () {
        const errors = this.getInvoiceValidationErrors()
        if (errors.length) {
          this.showInvoiceValidationErrors(errors)
          return
        }

        this.saveInvoice()
      },
      isLocationVatPayer (value) {
        return value === 1 || value === '1' || value === true
      },
      applySupplierDetailsFromCompany (company) {
        if (!company || typeof company !== 'object') return

        const rawCountry = String(company.country || 'RO').trim().toUpperCase()
        if (this.romaniaCountryOptions.some(item => item.code === rawCountry)) {
          this.invoiceCountryCode = rawCountry
        } else {
          this.invoiceCountryCode = 'RO'
        }

        this.invoiceCountyCode = this.resolveCountyCode(company.state) ||
          String(company.state || '').trim().toUpperCase() || ''
        this.invoiceCity = company.city || ''
        this.invoiceStreet = company.street || ''
        this.invoiceStreetNumber = company.numberAddress || ''
        this.invoiceVATPayer = company.isVatPayer === 1 || company.isVatPayer === true ? 'yes' : 'no'
      },
      applySupplierDetailsFromLocation (location) {
        if (!location || typeof location !== 'object') return

        const country = location.inv_country || location.country
        if (country) {
          const rawCountry = String(country).trim().toUpperCase()
          if (this.romaniaCountryOptions.some(item => item.code === rawCountry)) {
            this.invoiceCountryCode = rawCountry
          }
        }

        const county = location.inv_county || location.state
        if (county) {
          this.invoiceCountyCode = this.resolveCountyCode(county) ||
            String(county).trim().toUpperCase()
        }

        if (location.inv_city || location.city) {
          this.invoiceCity = location.inv_city || location.city
        }

        if (location.inv_address || location.street) {
          this.invoiceStreet = location.inv_address || location.street
        }

        const streetNumber = location.inv_street_number || location.number
        if (streetNumber) {
          this.invoiceStreetNumber = streetNumber
        }

        this.invoiceVATPayer = this.isLocationVatPayer(location.inv_is_vat_payer) ? 'yes' : 'no'
      },
      buildCompanyPayload () {
        const location = this.selectedLocation || {}
        const countyCode = this.invoiceCountyCode ||
          this.resolveCountyCode(location.state || location.inv_county || '')
        const countyName = this.getCountyName(countyCode)
        const city = this.invoiceCity || location.inv_city || location.city || ''
        const street = this.invoiceStreet || location.street || location.inv_address || ''
        const streetNumber = this.invoiceStreetNumber || location.inv_street_number || location.number || ''
        const addressParts = [street, streetNumber, city, countyName].filter(Boolean)

        const payload = {
          name: location.inv_company_name || location.name,
          vatNumber: location.inv_fiscal_code,
          address: addressParts.join(' '),
          street,
          city,
          country: this.invoiceCountryCode || 'RO',
          state: countyCode,
          numberAddress: streetNumber,
          isVatPayer: (this.invoiceVATPayer || (this.isLocationVatPayer(location.inv_is_vat_payer) ? 'yes' : 'no')) === 'yes' ? 1 : 0,
          phone: location.inv_phone,
          externalCompanyId: this.companyID
        }

        if (location.inv_bank_account) {
          payload.inv_bank_account = location.inv_bank_account
        }
        if (location.inv_bank) {
          payload.inv_bank = location.inv_bank
        }
        if (location.inv_bank_branch) {
          payload.inv_bank_branch = location.inv_bank_branch
        }

        return payload
      },
      getCountyName (code) {
        const county = this.romanianCounties.find(item => item.code === code)
        return county ? county.name : code
      },
      normalizeBucharestSector (value) {
        const raw = String(value || '').trim().toUpperCase().replace(/\s+/g, '')
        if (/^SECTOR[1-6]$/.test(raw)) return raw

        const match = String(value || '').trim().match(/^sector\s*([1-6])$/i)
        if (match) return `SECTOR${match[1]}`

        return String(value || '').trim()
      },
      isValidBucharestSector (value) {
        return this.bucharestSectors.some(sector => sector.code === value)
      },
      normalizeCountyName (name) {
        return String(name || '')
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
      },
      resolveCountyCode (value) {
        if (!value) return ''

        const trimmed = String(value).trim()
        const byCode = this.romanianCounties.find(item => item.code === trimmed.toUpperCase())
        if (byCode) return byCode.code

        const normalized = this.normalizeCountyName(trimmed)
        const byName = this.romanianCounties.find(item => this.normalizeCountyName(item.name) === normalized)
        return byName ? byName.code : ''
      },
      async saveCompany () {
        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/company?externalCompanyId=${encodeURIComponent(this.companyID)}`

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.buildCompanyPayload())
        })

        const data = await response.json()

        if (!response.ok) {
          throw new Error(data.error || data.message || 'Nu s-a putut salva compania.')
        }

        return data
      },
      async loadVats (locationId) {
        this.vats = await this.fetchVats(locationId)
      },
      onClientSelect (client) {
        if (client && client.id === 'add') {
          this.openAddClientModal()
          this.clientSelected = null
          this.clientName = ''
          this.clientCUI = ''
          this.clientEmail = ''
          this.clientPhone = ''
          this.clientCountryCode = 'RO'
          this.clientCountyCode = ''
          this.clientCity = ''
          this.clientStreet = ''
          this.clientStreetNumber = ''
          this.clientPostalCode = ''
        } else if (client) {
          this.clientSelected = client

          // Precompletăm câmpurile din v-model
          this.clientName = client.fullData.name || ''
          this.clientCUI = client.fullData.vatNumber || client.vatNumber || ''
          this.clientEmail = client.fullData.email || ''
          this.clientPhone = client.fullData.phone || ''
          const address = typeof client.fullData.address === 'string' ? client.fullData.address.trim() : ''
          const country = String(client.fullData.country || '').trim().toUpperCase()
          this.clientCountryCode = this.romaniaCountryOptions.some(item => item.code === country) ? country : 'RO'
          this.clientCountyCode = this.resolveCountyCode(client.fullData.county) || String(client.fullData.county || '').trim().toUpperCase()
          this.clientCity = this.clientCountyCode === 'B'
            ? this.normalizeBucharestSector(client.fullData.city)
            : client.fullData.city || ''
          this.clientStreet = address || client.fullData.street || ''
          this.clientStreetNumber = client.fullData.streetNumber || ''
          this.clientPostalCode = client.fullData.postalCode || ''
        } else {
          this.clientSelected = null
          this.clientName = ''
          this.clientCUI = ''
          this.clientEmail = ''
          this.clientPhone = ''
          this.clientCountryCode = 'RO'
          this.clientCountyCode = ''
          this.clientCity = ''
          this.clientStreet = ''
          this.clientStreetNumber = ''
          this.clientPostalCode = ''
        }
      },
      openAddClientModal () {
        this.client = {
          companyName: '',
          abbreviation: '',
          CUI: '',
          email: '',
          registrationNumber: '',
          address: '',
          bank: '',
          IBAN: '',
          dueDays: null,
          id: null,
          _rev: null
        }
        this.$modal.show('addClientModal')
      },
      openSeriesModal () {
        this.$modal.show('addSeriesModal')
      },
      async fetchClients (query) {
        this.fetchClientsCalled = true

        const vatNumber = this.selectedLocation && this.selectedLocation.inv_fiscal_code

        this.loading = true
        try {
          const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/customers` +
            `?name=${encodeURIComponent(query)}` +
            `&externalCompanyId=${this.companyID}` +
            (vatNumber ? `&vatNumber=${encodeURIComponent(vatNumber)}` : '')

          const response = await fetch(url)
          const data = await response.json()

          if (Array.isArray(data.customers)) {
            this.clientResults = [
              ...data.customers.map(client => ({
                id: client._id,
                nume: client.name,
                vatNumber: client.vatNumber,
                fullData: client
              })),
              { id: 'add', nume: '➕ Adaugă client' }
            ]
          } else {
            this.clientResults = [
              { id: 'add', nume: '➕ Adaugă client' }
            ]
          }
        } catch (error) {
          console.error('Error fetching clients:', error)
          this.clientResults = [
            { id: 'add', nume: '➕ Adaugă client' }
          ]
        } finally {
          this.loading = false
        }
      },
      async fetchLocation () {
        const dataToSend = {
          company_id: this.companyID,
          token: this.$session.get('token')
        }

        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.locations) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea locațiilor.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            return
          }

          this.locations = response.data.locations
        })
      },
      async fetchOrder (series, number) {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order?series=${series}&number=${number}&externalCompanyId=${this.companyID}`)
          if (!response.ok) {
            throw new Error(`Eroare la fetch order: ${response.status}`)
          }

          const data = await response.json()

          if (data) {
            this.myOrder = {
              ...data
            }

            if (data.externalLocationId) {
              this.selectedLocationId = data.externalLocationId
            }

            this.items = data.products.map(item => {
              const quantity = item.quantity_faptic || item.quantity_scriptic || 0
              const priceRON = item.pret_fara_tva || 0
              const vatRate = item.tva_percent != null ? item.tva_percent : 19
              const includeVAT = vatRate > 0 ? 'yes' : 'no'

              const priceFaraTVA = priceRON
              const tvaUnit = (priceFaraTVA * vatRate) / 100

              const totalFaraTVA = priceFaraTVA * quantity
              const totalTVA = tvaUnit * quantity

              return {
                posId: item.posId,
                productName: item.productName || '',
                type: item.type || 'N/A',
                code: item.code || 'N/A',
                unitMeasure: item.unitMeasure || 'BUC',
                quantity: quantity,
                priceRON: (priceFaraTVA + tvaUnit).toFixed(2),
                priceRON_gestiune: priceFaraTVA + tvaUnit,
                vatRate: String(vatRate),
                includeVAT: includeVAT,
                gestiuneFrom: item.gestiune,
                priceFaraTVA: priceFaraTVA.toFixed(2),
                valoare: (totalFaraTVA + totalTVA).toFixed(2),
                tva: totalTVA.toFixed(2)
              }
            })

            if (this.locations && this.locations.length) {
              this.populateClientFromLocation()
            }
          } else {
            console.error('Comandă invalidă primită:', data)
            swal({
              title: 'Eroare',
              text: 'Comanda nu a fost găsită.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          console.error('Eroare la fetch order:', error)
          swal({
            title: 'Eroare',
            text: 'A apărut o problemă la încărcarea comenzii.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      },
      parseDateTimeLocal (dateString) {
        if (!dateString) return ''
        const d = new Date(dateString)
        const yyyy = d.getFullYear()
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const dd = String(d.getDate()).padStart(2, '0')
        const hh = String(d.getHours()).padStart(2, '0')
        const min = String(d.getMinutes()).padStart(2, '0')
        return `${yyyy}-${mm}-${dd}T${hh}:${min}`
      },
      formatPaymentTypeLabel (paymentType) {
        if (!paymentType) return ''

        const key = `paymentTypes.${paymentType}`
        const translated = this.$t(key)
        return translated !== key ? translated : paymentType
      },
      applyOrderInfoFromApi (orderData) {
        if (!orderData) return

        this.orderDate = orderData.created_at_converted || ''
        this.orderNumber = orderData.id != null ? String(orderData.id) : ''
        this.bonData = orderData.fiscal_date_gmt || ''

        const fiscalNr = orderData.fiscal_nr
        const fiscalNrz = orderData.fiscal_nrz
        if (fiscalNr != null || fiscalNrz != null) {
          this.bonNumber = `NR: ${fiscalNr != null ? fiscalNr : '-'} Z: ${fiscalNrz != null ? fiscalNrz : '-'}`
        } else {
          this.bonNumber = ''
        }

        this.paymentType = orderData.payment_type || orderData.paymentType || ''
        this.syncBonNotaField()
      },
      parseBonNumberParts (bonNumber) {
        const match = String(bonNumber || '').match(/NR[:\s]*([^Z]+?)\s*Z[:\s]*(\S+)/i)
        if (!match) {
          return { nr: '', z: '' }
        }

        return {
          nr: match[1].trim(),
          z: match[2].trim()
        }
      },
      formatDateTimeForDisplay (value) {
        if (!value) return ''

        const normalized = String(value).trim().replace(' ', 'T')
        const date = new Date(normalized)

        if (!isNaN(date.getTime())) {
          const dd = String(date.getDate()).padStart(2, '0')
          const mm = String(date.getMonth() + 1).padStart(2, '0')
          const yyyy = date.getFullYear()
          const hh = String(date.getHours()).padStart(2, '0')
          const min = String(date.getMinutes()).padStart(2, '0')
          return `${dd}.${mm}.${yyyy}, ${hh}:${min}`
        }

        return String(value).trim()
      },
      parseOrderInfoFromObservatiiText (text) {
        if (!text) return null

        const value = String(text).trim()
        if (!value) return null

        try {
          const parsed = JSON.parse(value)
          if (parsed && typeof parsed === 'object') {
            const hasOrderInfo = !!(
              parsed.orderDate ||
              parsed.orderNumber ||
              parsed.bonData ||
              parsed.bonNumber
            )

            if (hasOrderInfo) {
              return {
                orderDate: parsed.orderDate || '',
                orderNumber: parsed.orderNumber != null ? String(parsed.orderNumber) : '',
                bonData: parsed.bonData || '',
                bonNumber: parsed.bonNumber || '',
                note: parsed.note || ''
              }
            }
          }
        } catch (e) {}

        const orderMatch = value.match(/Comand[aă]\s+nr\.\s*(\d+)\s+din\s+([^\n.]+)/i)
        const bonMatch = value.match(/Bon fiscal\s+NR\s*([^/]+)\s*\/\s*Z\s*(\S+)\s+din\s+([^\n.]+)/i)

        if (!orderMatch && !bonMatch) return null

        let note = value
        note = note.replace(/Comand[aă]\s+nr\.\s*\d+\s+din\s+[^\n.]+\.?\s*/i, '')
        note = note.replace(/Bon fiscal\s+NR\s*[^/]+\s*\/\s*Z\s*\S+\s+din\s+[^\n.]+\.?\s*/i, '')
        note = note.replace(/^\s+|\s+$/g, '')

        return {
          orderDate: orderMatch ? orderMatch[2].trim() : '',
          orderNumber: orderMatch ? String(orderMatch[1]) : '',
          bonData: bonMatch ? bonMatch[3].trim() : '',
          bonNumber: bonMatch
            ? `NR: ${bonMatch[1].trim()} Z: ${bonMatch[2].trim()}`
            : '',
          note
        }
      },
      getLocationInvAdditionalData () {
        const location = this.selectedLocation
        if (!location || !location.inv_additional_data) return ''
        return String(location.inv_additional_data).trim()
      },
      buildBonNotaText () {
        const lines = []

        if (this.orderNumber || this.orderDate) {
          const orderParts = []
          if (this.orderNumber) orderParts.push(`nr. ${this.orderNumber}`)
          if (this.orderDate) {
            orderParts.push(`din ${this.formatDateTimeForDisplay(this.orderDate)}`)
          }
          lines.push(`Comandă ${orderParts.join(' ')}.`)
        }

        if (this.bonNumber || this.bonData) {
          const { nr, z } = this.parseBonNumberParts(this.bonNumber)
          const bonParts = []
          if (nr || z) {
            bonParts.push(`NR ${nr || '-'} / Z ${z || '-'}`)
          }
          if (this.bonData) {
            bonParts.push(`din ${this.formatDateTimeForDisplay(this.bonData)}`)
          }
          lines.push(`Bon fiscal ${bonParts.join(' ')}.`)
        }

        if (this.paymentType) {
          lines.push(`Plată: ${this.formatPaymentTypeLabel(this.paymentType)}.`)
        }

        const additionalData = this.getLocationInvAdditionalData()
        if (additionalData) {
          lines.push(additionalData)
        }

        return lines.join('\n')
      },
      buildBonNotaTextFromParsed (parsed) {
        if (!parsed) return ''

        const lines = []

        if (parsed.orderNumber || parsed.orderDate) {
          const orderParts = []
          if (parsed.orderNumber) orderParts.push(`nr. ${parsed.orderNumber}`)
          if (parsed.orderDate) {
            orderParts.push(`din ${this.formatDateTimeForDisplay(parsed.orderDate)}`)
          }
          lines.push(`Comandă ${orderParts.join(' ')}.`)
        }

        if (parsed.bonNumber || parsed.bonData) {
          const { nr, z } = this.parseBonNumberParts(parsed.bonNumber)
          const bonParts = []
          if (nr || z) {
            bonParts.push(`NR ${nr || '-'} / Z ${z || '-'}`)
          }
          if (parsed.bonData) {
            bonParts.push(`din ${this.formatDateTimeForDisplay(parsed.bonData)}`)
          }
          lines.push(`Bon fiscal ${bonParts.join(' ')}.`)
        }

        const additionalData = this.getLocationInvAdditionalData()
        if (additionalData) {
          lines.push(additionalData)
        }

        return lines.join('\n')
      },
      syncBonNotaField () {
        const text = this.buildBonNotaText()
        if (text) {
          this.bonNota = text
        }
      },
      buildobservatiiFacturaText () {
        return this.buildBonNotaText()
      },
      buildobservatiiFacturaTextFromParsed (parsed) {
        return this.buildBonNotaTextFromParsed(parsed)
      },
      syncobservatiiFacturaField () {
        this.syncBonNotaField()
      },
      parseOrderInfoFromNotaInterna (notaInterna) {
        return this.parseOrderInfoFromObservatiiText(notaInterna)
      },
      buildOrderInfoNotaInternaForSave () {
        return this.buildBonNotaText()
      },
      loadOrderInfoFromInvoice (data, extraFieldsMap = {}) {
        this.paymentType = data.paymentType || data.payment_type || extraFieldsMap.paymentType || extraFieldsMap.payment_type || ''

        let parsed = null

        if (data.orderDate || data.orderNumber || data.bonData || data.bonNumber) {
          this.orderDate = data.orderDate || ''
          this.orderNumber = data.orderNumber != null ? String(data.orderNumber) : ''
          this.bonData = data.bonData || ''
          this.bonNumber = data.bonNumber || ''
          parsed = {
            orderDate: this.orderDate,
            orderNumber: this.orderNumber,
            bonData: this.bonData,
            bonNumber: this.bonNumber
          }
        }

        if (data.bonNota) {
          this.bonNota = data.bonNota
          parsed = parsed || this.parseOrderInfoFromObservatiiText(data.bonNota)
        } else if (!this.bonNota && parsed) {
          this.bonNota = this.buildBonNotaText()
        }

        if (!parsed && extraFieldsMap.observatiiFactura) {
          this.bonNota = extraFieldsMap.observatiiFactura
          parsed = this.parseOrderInfoFromObservatiiText(extraFieldsMap.observatiiFactura)
        }

        if (!parsed && extraFieldsMap.observatiiComanda) {
          this.bonNota = extraFieldsMap.observatiiComanda
          parsed = this.parseOrderInfoFromObservatiiText(extraFieldsMap.observatiiComanda)
        }

        if (!parsed && extraFieldsMap.notaInterna) {
          parsed = this.parseOrderInfoFromObservatiiText(extraFieldsMap.notaInterna)
          if (parsed) {
            this.bonNota = this.buildBonNotaTextFromParsed(parsed)
            if (parsed.note) {
              this.extraFields.notaInterna = parsed.note
            }
          }
        }

        if (parsed && !(data.orderDate || data.orderNumber || data.bonData || data.bonNumber)) {
          this.orderDate = parsed.orderDate
          this.orderNumber = parsed.orderNumber
          this.bonData = parsed.bonData
          this.bonNumber = parsed.bonNumber
        } else if (!parsed) {
          this.orderDate = data.orderDate || extraFieldsMap.orderDate || ''
          this.orderNumber = data.orderNumber != null
            ? String(data.orderNumber)
            : (extraFieldsMap.orderNumber || '')
          this.bonData = data.bonData || extraFieldsMap.bonData || ''
          this.bonNumber = data.bonNumber || extraFieldsMap.bonNumber || ''
          if (!this.bonNota && this.hasOrderInfo) {
            this.bonNota = this.buildBonNotaText()
          }
        }

        if (this.orderNumber) {
          this.searchTerm = String(this.orderNumber)
        }
      },
      async getInvoiceDetails (invoiceId) {
        if (!invoiceId) {
          console.error('Missing invoice ID')
          return
        }

        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/getDocument/?tip=invoice&series=${this.series}&number=${this.invoiceNumber}&externalCompanyId=${this.companyID}`

        try {
          const response = await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const result = await response.json()
          const data = result.documents && result.documents.length ? result.documents[0] : null

          this.parentSeries = data.series
          this.parentInvoiceNumber = data.invoiceNumber

          this.invoiceData = data
          this.items = data.items.map(item => {
            const rawQuantity = parseFloat(item.quantity) || 0
            const quantity = this.isStorno ? -1 * Math.abs(rawQuantity) : rawQuantity
            const priceRON = parseFloat(item.price) || 0      // preț fara TVA
            const vatRate = item.tva != null ? parseFloat(item.tva) || 0 : 19
            const includeVAT = vatRate > 0 ? 'yes' : 'no'

            const priceFaraTVA = priceRON
            const totalFaraTVA = +(priceFaraTVA * quantity).toFixed(2)
            const totalTVA = +((priceFaraTVA * quantity * vatRate / 100).toFixed(2))
            const totalValoare = +(totalFaraTVA + totalTVA).toFixed(2)

            return {
              posId: item.posId,
              productName: item.name || '',
              type: item.type || 'N/A',
              code: item.code || 'N/A',
              unitMeasure: item.unitMeasure || 'BUC',
              quantity: quantity,
              priceRON: priceRON.toFixed(2),
              priceRON_gestiune: priceRON,
              vatRate: String(vatRate),
              includeVAT: includeVAT,
              gestiuneFrom: item.gestiune_from,
              priceFaraTVA: priceFaraTVA.toFixed(2),
              valoare: totalValoare.toFixed(2),
              tva: totalTVA.toFixed(2)
            }
          })
          this.currency = data.currency
          this.seriesNumber = data.series
          this.clientName = data.customer.name
          this.clientCUI = data.customer.cnp
          this.clientEmail = data.customer.email
          this.clientPhone = data.customer.phone
          this.clientCountryCode = 'RO'
          const rawCountry = String(data.customer.country || '').trim().toUpperCase()
          if (this.romaniaCountryOptions.some(item => item.code === rawCountry)) {
            this.clientCountryCode = rawCountry
          }
          this.clientCountyCode = this.resolveCountyCode(data.customer.county) || String(data.customer.county || '').trim().toUpperCase() || ''
          const loadedCity = data.customer.city || ''
          this.clientCity = this.clientCountyCode === 'B'
            ? this.normalizeBucharestSector(loadedCity)
            : loadedCity
          this.clientStreet = data.customer.street || ''
          this.clientStreetNumber = data.customer.streetNumber || ''
          this.clientPostalCode = data.customer.postalCode || ''

          if (data.company) {
            this.applySupplierDetailsFromCompany(data.company)
          }

          this.seriesOptions = [{
            series: data.series,
            currentNumber: data.invoiceNumber
          }]
          this.seriesNumber = data.series
          this.currentNumber = data.invoiceNumber

          if (data.extraFields) {
            this.extraFields = data.extraFields.reduce((acc, field) => {
              acc[field.key] = field.value
              return acc
            }, { ...this.extraFields })
          }

          this.loadOrderInfoFromInvoice(data, this.extraFields)

          if (!this.isStorno) {
            this.issueDate = this.parseDateTimeLocal(data.issueDate || data.date)
            this.dueDate = this.parseDateTimeLocal(data.dueDate || data.date)
          }

          if (data.externalLocationId && this.locations && this.locations.length) {
            // Căutăm locația potrivită în groupedLocations
            let foundLocation = null
            for (const group of this.groupedLocations) {
              foundLocation = group.locations.find(loc =>
                (data.externalLocationId && loc.true_id === data.externalLocationId) ||
                (data.vatNumber && loc.inv_fiscal_code === data.vatNumber)
              )
              if (foundLocation) break
            }
            if (foundLocation) {
              this.selectedLocationId = foundLocation.true_id
            }
          }

          if (data.customer) {
            console.log('Customer data found:', data.customer)
            const customer = data.customer
            const clientObj = {
              id: 'temp-' + customer.cnp,
              nume: customer.name,
              vatNumber: customer.cnp,
              fullData: customer
            }

            this.clientSelected = clientObj
            console.log('Selected client from invoice:', clientObj)
            this.onClientSelect(clientObj)
          }
        } catch (error) {
          console.error('Error fetching invoice details:', error)
        }
      },
      async fetchCompanyDetails (cui) {
        try {
          const company = await this.fetchAnafCompanyByCui(cui)
          this.applyAnafCompanyToFields(company, 'invoiceClient')
        } catch (error) {
          console.error('Error fetching company details:', error)
        }
      },
      searchOrder () {
        const id = this.searchTerm ? parseInt(this.searchTerm.trim(), 10) : null
        var data = {
          token: this.$session.get('token'),
          company_id: this.companyID,
          id: id
        }

        if (!id) {
          swal({
            type: 'warning',
            title: 'Atenție',
            text: 'Te rog introdu un ID de comandă.'
          })
          return
        }

        swal({
          title: 'Se caută comanda...',
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          content: {
            element: 'div',
            attributes: {
              innerHTML: '<div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>'
            }
          }
        })

        this.apiRequest('/get-products-from-order/', 'GET', data, (response) => {
          swal.close()

          if (response.status === true && response.data && Array.isArray(response.data.items) && response.data.items.length > 0) {
            this.isDisabled = true
            this.linkedOrderId = response.data.id != null ? response.data.id : id

            const firstGestiune = this.gestiuniList.length ? this.gestiuniList[0].name : ''
            this.receipt_number = response.data.receipt_number || null
            this.applyOrderInfoFromApi(response.data)

            this.items = response.data.items.map(item => {
              const rawQuantity = parseFloat(item.quantity)
              const rawPrice = parseFloat(item.price)
              let quantity = Number.isFinite(rawQuantity) ? rawQuantity : 1
              let price = Number.isFinite(rawPrice) ? rawPrice : 0
              // Păstrăm quantity negativ din API; dacă price e încă negativ, mutăm semnul pe cantitate
              if (price < 0) {
                if (quantity > 0) quantity = -quantity
                else if (quantity === 0) quantity = -1
                price = Math.abs(price)
              }
              const vatRate = item.vat != null ? item.vat : ''
              const includeVAT = item.includeVAT === 'no' ? 'no' : 'yes'

              let priceFaraTVA = 0
              let tvaUnit = 0
              let priceCuTVA = 0

              if (includeVAT === 'yes') {
                priceCuTVA = price
                priceFaraTVA = price / (1 + vatRate / 100)
                tvaUnit = price - priceFaraTVA
              } else {
                priceFaraTVA = price
                tvaUnit = price * (vatRate / 100)
                priceCuTVA = price + tvaUnit
              }

              const totalFaraTVA = priceFaraTVA * quantity
              const totalTVA = tvaUnit * quantity

              return {
                productName: item.name || '',
                type: item.type || 'N/A',
                code: item.product_code || 'N/A',
                unitMeasure: item.unit || 'BUC',
                quantity: quantity,
                priceRON: priceFaraTVA.toFixed(2),     // << aici punem prețul fără TVA
                priceRON_gestiune: priceFaraTVA,
                priceCuTVA: priceCuTVA.toFixed(2),
                vatRate: String(vatRate),
                includeVAT: includeVAT,
                gestiune: firstGestiune,
                priceFaraTVA: priceFaraTVA.toFixed(2),
                valoare: (totalFaraTVA + totalTVA).toFixed(2),
                tva: totalTVA.toFixed(2)
              }
            })

            swal({
              icon: 'success',
              title: 'Comandă găsită',
              text: `Am preluat ${this.items.length} articole din comandă.`
            })
          } else if (response && response.status === false) {
            this.showOrderApiError(response, 'Comanda nu a fost găsită.')
          } else {
            swal({
              icon: 'error',
              title: 'Eroare',
              text: 'Comanda nu a fost găsită.'
            })
          }
        })
      },
      escapeSwalHtml (value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
      },
      getOrderApiErrorInfo (response) {
        const errors = (response && response.errors) || {}
        const data = (response && response.data) || {}
        const isObject = errors && typeof errors === 'object' && !Array.isArray(errors)

        let message = ''
        if (isObject && typeof errors.message === 'string' && errors.message) {
          message = errors.message
        } else if (response && typeof response.message === 'string' && response.message) {
          message = response.message
        } else if (isObject) {
          message = Object.keys(errors)
            .filter((key) => !['code', 'invoice_series', 'invoice_number', 'message'].includes(key))
            .map((key) => {
              const value = errors[key]
              if (Array.isArray(value)) return value.join(' ')
              if (typeof value === 'string') return value
              return ''
            })
            .filter(Boolean)
            .join('\n')
        }

        return {
          message,
          code: isObject ? errors.code : '',
          invoiceSeries: (isObject && errors.invoice_series) || data.invoice_series || '',
          invoiceNumber: (isObject && errors.invoice_number) || data.invoice_number || '',
          isStorno: data.is_invoice_storno === 1 || data.is_invoice_storno === true
        }
      },
      showOrderApiError (response, fallbackText = 'A apărut o eroare.') {
        const info = this.getOrderApiErrorInfo(response)
        const message = info.message || fallbackText
        const isAlreadyInvoiced = info.code === 'ORDER_ALREADY_HAS_INVOICE'
        const detailRows = []

        if (info.invoiceSeries) {
          detailRows.push(
            `<div style="padding:4px 0;font-size:13px;color:#7a8ba8;">` +
            `Serie: <strong style="color:#25396F;">${this.escapeSwalHtml(info.invoiceSeries)}</strong></div>`
          )
        }
        if (info.invoiceNumber) {
          detailRows.push(
            `<div style="padding:4px 0;font-size:13px;color:#7a8ba8;">` +
            `Număr: <strong style="color:#25396F;">${this.escapeSwalHtml(info.invoiceNumber)}</strong></div>`
          )
        }
        if (info.isStorno) {
          detailRows.push(
            `<div style="padding:4px 0;font-size:13px;color:#7a8ba8;">` +
            `Tip: <strong style="color:#25396F;">Storno</strong></div>`
          )
        }

        const html =
          `<div style="text-align:center;">` +
          `<p style="margin:0 0 12px;font-size:15px;color:#25396F;line-height:1.45;">${this.escapeSwalHtml(message)}</p>` +
          (detailRows.length
            ? `<div style="background:#f8fafd;border:1px solid #e8edf5;border-radius:8px;padding:10px 12px;display:inline-block;min-width:180px;">${detailRows.join('')}</div>`
            : '') +
          `</div>`

        swal({
          title: isAlreadyInvoiced ? 'Factură existentă' : 'Eroare',
          html,
          type: isAlreadyInvoiced ? 'warning' : 'error',
          confirmButtonText: 'OK'
        })
      },
      calculateItemTotals (item) {
        const quantity = Number(item.quantity) // Cantitatea
        const priceRON = Number(item.priceRON) // Prețul cu TVA inclus
        const vatRate = Number(item.vatRate) // Cota TVA
        const includeVAT = item.includeVAT === 'yes' // Verificăm dacă prețul include TVA

        console.log('Calculating totals for item:', vatRate)
        console.log('Include VAT:', includeVAT)

        let priceFaraTVA, tvaUnit, totalFaraTVA, totalTVA

        if (includeVAT) {
          // Dacă prețul include TVA, calculăm prețul fără TVA
          priceFaraTVA = priceRON / (1 + vatRate / 100) // Prețul fără TVA
          tvaUnit = priceRON - priceFaraTVA // TVA pe unitate
        } else {
          // Dacă prețul nu include TVA, atunci prețul fără TVA este direct priceRON
          priceFaraTVA = priceRON
          tvaUnit = priceFaraTVA * vatRate / 100 // Calculăm TVA pe unitate
        }

        // Calculăm totalurile pentru cantitatea selectată
        totalFaraTVA = priceFaraTVA * quantity // Total fără TVA
        totalTVA = tvaUnit * quantity // TVA total

        // Returnăm valorile calculate
        return {
          priceFaraTVA, // Prețul fără TVA
          total: totalFaraTVA + totalTVA, // Valoarea totală cu TVA inclus
          tva: totalTVA // TVA total
        }
      },
      populateClientFromLocation () {
        if (this.myOrder && this.myOrder.supplierExternalLocationId) {
          const matchedLocation = this.locations.find(
            loc => loc.true_id === this.myOrder.supplierExternalLocationId
          )

          if (matchedLocation) {
            this.clientName = matchedLocation.inv_company_name || ''
            this.clientCUI = matchedLocation.inv_fiscal_code || ''
            this.clientEmail = matchedLocation.inv_email || ''
            this.clientPhone = matchedLocation.inv_phone || ''
          }
        }
      },
      addItem () {
        if (
          this.newItem.gestiuneId &&
          this.newItem.productName &&
          this.newItem.unitMeasure &&
          this.newItem.quantity >= 0 &&
          this.newItem.priceRON >= 0 &&
          this.newItem.type &&
          this.newItem.code &&
          this.newItem.vatRate !== null &&
          this.newItem.includeVAT !== ''
        ) {
          const totals = this.calculateItemTotals(this.newItem)

          console.log(totals)
          const newItemWithTotals = {
            ...this.newItem,
            priceRON: totals.priceFaraTVA.toFixed(2),
            priceRON_gestiune: totals.priceFaraTVA,
            valoare: totals.total.toFixed(2),
            tva: totals.tva.toFixed(2),
            gestiuneFrom: this.newItem.gestiuneId
          }
          this.items.push(newItemWithTotals)
          this.resetNewItem()
        } else {
          // Mesaj de eroare dacă lipsește ceva
        }
      },
      getGestiuneName (gestiuneId) {
        const gestiune = this.gestiuneOptions.find(g => g.id === gestiuneId)
        return gestiune ? gestiune.name : 'N/A'
      },
      removeItem (index) {
        this.items.splice(index, 1)
      },
      resetNewItem () {
        this.newItem = {
          gestiuneId: null,
          productName: '',
          unitMeasure: '',
          quantity: null,
          priceRON: null,
          type: '',
          code: '',
          vatRate: '',
          includeVAT: 'no'
        }
      },
      async getSeries (vatNumber) {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              externalCompanyId: this.companyID,
              vatNumber: vatNumber,
              tip: 'invoice'
            })
          })

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const data = await response.json()

          if (Array.isArray(data.series) && data.series.length > 0) {
            this.seriesOptions = data.series.map(serie => ({
              series: serie.series,
              currentNumber: serie.currentNumber
            }))

            this.seriesNumber = this.seriesOptions[0].series
            this.currentNumber = this.seriesOptions[0].currentNumber
          } else {
            console.warn('Nu există serii disponibile pentru acest cod fiscal.')

            // Resetăm datele
            this.seriesOptions = []
            this.seriesNumber = ''
            this.currentNumber = ''
          }
        } catch (error) {
          console.error('Error fetching series:', error)

          // Resetăm datele
          this.seriesOptions = []
          this.seriesNumber = ''
          this.currentNumber = ''
        }
      },
      async fetchGestiuni () {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
          if (!response.ok) throw new Error('Failed to fetch gestiuni')

          const data = await response.json()
          if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
            this.gestiuneOptions = data.gestiuni.map((gest) => ({
              id: gest._id,
              name: `${gest.name} (${gest.cod_gestiune})`,
              externalLocationId: gest.externalLocationId || ''
            }))
          } else {
            this.$message.error('Nu s-a primit un array valid de la server.')
          }
        } catch (error) {
          this.$message.error(`Request failed: ${error.message}`)
          console.error('Error fetching management data:', error)
        }
      },
      updateNumber () {
        if (this.seriesNumber === 'add') {
          this.openSeriesModal()
          return
        }

        const selectedSeries = this.seriesOptions.find(
          (series) => series.series === this.seriesNumber
        )

        if (selectedSeries) {
          this.currentNumber = selectedSeries.currentNumber
        } else {
          this.currentNumber = ''
        }
      },
      async fetchProducts (searchTerm) {
        if (!searchTerm || searchTerm.length < 2) {
          this.searchResults = []
          return
        }

        this.loadingProducts = true
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}&name=${searchTerm}`)
          const data = await response.json()

          if (Array.isArray(data.products)) {
            this.searchResults = [
              ...data.products
            ]
          }
        } catch (error) {
          console.error('Error fetching products:', error)
        } finally {
          this.loadingProducts = false
        }
      },
      onProductSelected (selectedProduct) {
        if (typeof selectedProduct === 'string' || !selectedProduct) {
          this.resetNewItem()
          return
        }

        this.newItem.posId = selectedProduct.posId || selectedProduct._id
        this.newItem.code = selectedProduct.product_code || ''
        this.newItem.type = selectedProduct.categorie || ''
        this.newItem.unitMeasure = selectedProduct.um || ''
        this.newItem.quantity = selectedProduct.quantity || 1
        this.newItem.priceRON = (
          selectedProduct.pret_vanzare &&
          selectedProduct.pret_vanzare.length > 0 &&
          selectedProduct.pret_vanzare[0].price
        ) || ''
        this.newItem.vatRate = selectedProduct.vat_percent != null ? String(selectedProduct.vat_percent) : ''
        this.newItem.includeVAT = selectedProduct.is_with_vat ? 'yes' : 'no'
      },
      getClientTypeCode (status) {
        switch (status) {
          case 'juridica_ro':
            return 1 // Persoană juridică România
          case 'fizica':
            return 2 // Persoană fizică
          case 'juridica_vies':
            return 3 // PJ VIES
          default:
            return 1 // fallback
        }
      },
      async submitToAdminInvoice (invoiceResponse) {
        console.log('Heading to submit to admin invoice with response:', invoiceResponse)
        try {
          const adminData = {
            _id: invoiceResponse._id,
            company_id: this.companyID,
            order_id: this.searchTerm,
            series: invoiceResponse.series,
            number: invoiceResponse.invoiceNumber,
            is_vat_payer: this.clientVATPayer.toLowerCase() === 'yes',
            client_type: this.getClientTypeCode(this.clientLegalStatus),
            cui: this.clientCUI,
            email: this.clientEmail,
            phone: this.clientPhone,
            address: '',
            client_full_name: this.clientName,
            issue_date: invoiceResponse.date.split('T')[0],
            payment_type: this.paymentType,
            receipt_number: this.receiptNumber || '',
            token: this.$session.get('vue-session-key'),
            jwtoken: this.apiClientKey
          }

          // Log înainte de trimitere
          console.log('Submitting invoice to administration API:', adminData)

          const adminResponse = await this.apiRequest(
            '/client-api/administration/invoice',
            'POST',
            adminData,
            (response) => {
              console.log('Intermediate response from API (callback):', response)
            }
          )

          // Log final
          console.log('Final response from administration API:', adminResponse)

          if (adminResponse && !adminResponse.status) {
            console.error('Admin invoice error:', adminResponse.error)
            swal({
              title: 'Error',
              text: (adminResponse.error && adminResponse.error.message) ? adminResponse.error.message : 'Error submitting to administration.',
              icon: 'error',
              timer: 3000,
              showConfirmButton: false
            })
          } else {
            console.log('Admin invoice submitted successfully.', adminResponse && adminResponse.data ? adminResponse.data : adminResponse)
          }
        } catch (err) {
          console.error('Exception while submitting admin invoice:', err)
          swal({
            title: 'Exception',
            text: err.message || 'Unexpected error occurred.',
            icon: 'error',
            timer: 3000,
            showConfirmButton: false
          })
        }
      },
      markNexusInvoice (orderId, action, invoiceSeries, invoiceNumber) {
        if (!orderId) return

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          order_id: orderId,
          action
        }

        if (action === 'send') {
          if (invoiceSeries) data.invoice_series = invoiceSeries
          if (invoiceNumber != null && invoiceNumber !== '') data.invoice_number = invoiceNumber
        }

        this.apiRequest('/nexus/invoice/mark', 'POST', data, (response) => {
          if (!(response && response.status)) {
            console.warn('Nexus invoice mark failed:', response)
          }
        })
      },
      fetchNexusInvoiceStatus () {
        if (!this.nexusOrderId) return

        this.apiRequest(`/nexus/invoice/status/${this.nexusOrderId}`, 'GET', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }, (response) => {
          if (response && response.status) {
            this.showNexusInvoiceStatusSwal(response.data != null ? response.data : response)
          } else {
            swal('', this.$t('validations.wentWrong'), 'error')
          }
        })
      },
      showNexusInvoiceStatusSwal (payload) {
        const status = Number(
          payload && (payload.nexus_invoice_status != null
            ? payload.nexus_invoice_status
            : payload.status)
        )
        const config = this.getNexusInvoiceStatusSwalConfig(status)
        swal({
          title: config.title,
          text: config.text,
          type: config.type
        })
      },
      getNexusInvoiceStatusSwalConfig (status) {
        const map = {
          1: { type: 'info', titleKey: 'nexus.invoiceStatus1', textKey: 'nexus.invoiceStatus1Text' },
          2: { type: 'info', titleKey: 'nexus.invoiceStatus2', textKey: 'nexus.invoiceStatus2Text' },
          3: { type: 'success', titleKey: 'nexus.invoiceStatus3', textKey: 'nexus.invoiceStatus3Text' },
          4: { type: 'error', titleKey: 'nexus.invoiceStatus4', textKey: 'nexus.invoiceStatus4Text' },
          5: { type: 'warning', titleKey: 'nexus.invoiceStatus5', textKey: 'nexus.invoiceStatus5Text' },
          6: { type: 'success', titleKey: 'nexus.invoiceStatus6', textKey: 'nexus.invoiceStatus6Text' },
          7: { type: 'error', titleKey: 'nexus.invoiceStatus7', textKey: 'nexus.invoiceStatus7Text' }
        }
        const item = map[status]
        if (!item) {
          return {
            type: 'info',
            title: this.$t('nexus.invoiceStatus'),
            text: this.$t('nexus.invoiceStatusUnknown')
          }
        }
        return {
          type: item.type,
          title: this.$t(item.titleKey),
          text: this.$t(item.textKey)
        }
      },
      fetchNexusInvoiceLogs () {
        if (!this.nexusOrderId) return

        this.apiRequest(`/nexus/invoice/logs/${this.nexusOrderId}`, 'GET', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }, (response) => {
          if (response && response.status) {
            swal({
              title: this.$t('nexus.invoiceLog'),
              html: `<pre style="text-align:left;max-height:400px;overflow:auto;">${JSON.stringify(response.data != null ? response.data : response, null, 2)}</pre>`
            })
          } else {
            swal('', this.$t('validations.wentWrong'), 'error')
          }
        })
      },
      markNexusInvoiceManual () {
        if (!this.nexusOrderId) return

        const series = this.seriesNumber || (this.invoiceData && this.invoiceData.series) || this.series
        const number = this.currentNumber || (this.invoiceData && this.invoiceData.invoiceNumber) || this.invoiceNumber

        this.markNexusInvoice(
          this.nexusOrderId,
          this.isStorno ? 'storno' : 'send',
          series,
          number
        )
        swal('', this.$t('nexus.invoiceMarkSuccess'), 'success')
      },
      async updateOrderInvoiceFromSearch (invoiceResponse) {
        if (this.isEdit || !this.linkedOrderId) return { status: true, skipped: true }

        const invoiceSeries = invoiceResponse && invoiceResponse.series
        const invoiceNumber = invoiceResponse && invoiceResponse.invoiceNumber
        if (!invoiceSeries || invoiceNumber == null || invoiceNumber === '') return { status: true, skipped: true }

        const payload = {
          token: this.$session.get('token'),
          company_id: this.companyID,
          id: this.linkedOrderId,
          invoice_series: String(invoiceSeries),
          invoice_number: String(invoiceNumber)
        }

        return new Promise((resolve) => {
          this.apiRequest(
            '/update-order-invoice',
            'POST',
            payload,
            (response) => {
              resolve(response || { status: false })
            }
          )
        })
      },
      async updateOrderWithInvoice (series, number) {
        const currentExternalDocs = this.myOrder.externalDocIds || {}

        const updateOrderPayload = {
          ...this.myOrder,
          externalDocIds: {
            ...currentExternalDocs,
            invoice: {
              series,
              number
            }
          },
          status: 'facturat'
        }

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateOrderPayload)
          })

          if (!response.ok) {
            console.warn('Order update with aviz_id failed')
          } else {
            console.log('Order updated with aviz:', series, number)
          }
        } catch (err) {
          console.error('Error updating order with aviz_id:', err)
        }
      },
      async saveInvoice () {
        const validationErrors = this.getInvoiceValidationErrors()
        if (validationErrors.length) {
          this.showInvoiceValidationErrors(validationErrors)
          return
        }

        try {
          await this.saveCompany()
        } catch (error) {
          console.error('Error saving company:', error)
          swal({
            title: 'Error',
            text: error.message || 'Nu s-a putut salva compania.',
            type: 'error',
            timer: 2500,
            showConfirmButton: false
          })
          return
        }

        const bonNotaValue = this.bonNota || this.buildBonNotaText()

        const extraFieldsForSave = { ...this.extraFields }
        delete extraFieldsForSave.orderDate
        delete extraFieldsForSave.orderNumber
        delete extraFieldsForSave.bonData
        delete extraFieldsForSave.bonNumber

        if (bonNotaValue) {
          extraFieldsForSave.observatiiFactura = bonNotaValue
        }

        if (this.paymentType) {
          extraFieldsForSave.paymentType = this.paymentType
        }

        const invoiceData = {
          tip: 'invoice',
          externalCompanyId: this.companyID,
          externalLocationId: this.selectedLocation.true_id,
          vatNumber: this.selectedLocation.inv_fiscal_code,
          dueDate: this.dueDate,
          issueDate: this.issueDate,
          items: this.items.map(item => ({
            posId: item.posId,
            name: item.productName.name || item.productName,
            type: item.type,
            code: item.code,
            unitMeasure: item.unitMeasure,
            quantity: item.quantity,
            price: parseFloat(
              item.priceRON_gestiune != null && item.priceRON_gestiune !== ''
                ? item.priceRON_gestiune
                : item.priceRON
            ),
            tva: item.vatRate,
            gestiune_from: item.gestiuneId || item.gestiuneFrom
          })),
          currency: this.currency,
          series: this.seriesNumber,
          customer: {
            name: this.clientName,
            cnp: this.clientCUI,
            email: this.clientEmail,
            phone: this.clientPhone,
            country: this.clientCountryCode,
            county: this.clientCountyCode,
            city: this.clientCity,
            street: this.clientStreet,
            streetNumber: this.clientStreetNumber,
            postalCode: this.clientPostalCode
          },
          extraFields: Object.entries(extraFieldsForSave).map(([key, value]) => ({ key, value })),
          orderDate: this.orderDate,
          orderNumber: this.orderNumber,
          bonData: this.bonData,
          bonNumber: this.bonNumber,
          bonNota: bonNotaValue,
          paymentType: this.paymentType,
          payment_type: this.paymentType,
          parentDocument: this.parentSeries && this.parentInvoiceNumber
            ? `${this.parentSeries}-${this.parentInvoiceNumber}`
            : null
        }

        if (this.isEdit && this.invoiceData && this.invoiceData.invoiceNumber) {
          invoiceData.number = this.invoiceData.invoiceNumber
        }

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/document`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(invoiceData)
          })

          if (!response.ok) {
            const errorData = await response.json()
            const errorMessage = errorData.error || 'Error saving invoice'

            swal({
              title: 'Error',
              text: errorMessage,
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })

            throw new Error('Error saving invoice')
          }

          const data = await response.json()
          console.log('Invoice saved successfully:', data)

          await this.submitToAdminInvoice(data)
          const orderInvoiceResponse = await this.updateOrderInvoiceFromSearch(data)

          const { isInvoice } = this.route.query
          if (isInvoice && data.series && data.invoiceNumber) {
            await this.updateOrderWithInvoice(data.series, data.invoiceNumber)
          }

          if (!this.isEdit && this.hasNexusLocation) {
            const orderId = this.nexusOrderId || (data.orderNumber != null ? String(data.orderNumber) : '')
            if (orderId) {
              this.markNexusInvoice(
                orderId,
                this.isStorno ? 'storno' : 'send',
                data.series,
                data.invoiceNumber
              )
            }
          }

          if (orderInvoiceResponse && orderInvoiceResponse.status === false) {
            this.showOrderApiError(orderInvoiceResponse, 'Nu s-a putut asocia factura la comandă.')
          } else {
            swal({
              title: 'Success',
              text: 'Invoice saved successfully.',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })
          }

          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
          // if (this.isInvoice) {
          //   this.$router.push('/management/sidebar?tab=ordersSuppliers')
          // } else {
          //   this.$router.push('/management/sidebar?tab=outputs')
          // }
        } catch (error) {
          console.error('Error saving invoice:', error)

          swal({
            title: 'Error',
            text: error.message || 'An unexpected error occurred.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      }
    }
  }
  </script>

<style scoped>
  .btn-primary {
    padding: 5px 50px;
  }
  .box {
    display: flex ;
    justify-content: space-between;
    align-items: center;
  }
  .search {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .observatii-comanda-textarea {
    min-height: 96px;
    font-size: 13px;
    line-height: 1.5;
    color: #25396F;
    background: #f8fafd;
    border-color: #e8edf5;
    resize: vertical;
  }
  .order-info-summary {
    margin-top: 16px;
    padding: 0;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafd 100%);
    border: 1px solid #e8edf5;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 18px rgba(37, 57, 111, 0.06);
  }
  .order-info-header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 18px;
    background: linear-gradient(90deg, rgba(255, 142, 0, 0.08) 0%, rgba(37, 57, 111, 0.04) 100%);
    border-bottom: 1px solid #edf1f7;
  }
  .order-info-header-icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    background: linear-gradient(135deg, #ff8e00 0%, #ff7300 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(255, 142, 0, 0.28);
  }
  .order-info-title {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #25396F;
    line-height: 1.2;
  }
  .order-info-subtitle {
    margin: 3px 0 0;
    font-size: 12px;
    color: #7a8ba8;
    line-height: 1.3;
  }
  .order-info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 12px;
    padding: 14px 16px 16px;
  }
  .order-info-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    background: #fff;
    border: 1px solid #edf1f7;
    border-radius: 8px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  }
  .order-info-card:hover {
    border-color: #d7e0ef;
    box-shadow: 0 6px 16px rgba(37, 57, 111, 0.07);
    transform: translateY(-1px);
  }
  .order-info-card--highlight {
    background: linear-gradient(135deg, #fffaf4 0%, #fff 100%);
    border-color: rgba(255, 142, 0, 0.22);
  }
  .order-info-card--highlight .order-info-card-icon {
    background: rgba(255, 142, 0, 0.12);
    color: #ff8e00;
  }
  .order-info-card-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: rgba(37, 57, 111, 0.07);
    color: #25396F;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    flex-shrink: 0;
  }
  .order-info-card-body {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  .order-info-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #8a97ad;
    margin-bottom: 4px;
  }
  .order-info-value {
    font-size: 14px;
    font-weight: 700;
    color: #25396F;
    line-height: 1.35;
    word-break: break-word;
  }
  .button-group {
    display: flex;
    justify-content: flex-end;
  }
  .button-group .btn {
    margin-right: 10px;
  }
  .button-group .btn:last-child {
    margin-right: 0;
  }
  .v-select input[type=search], .v-select input[type=search]:focus, .v-select.searchable .dropdown-toggle {
    min-height: 46px;
    height: 46px;
  }
  .client-address-section {
    margin-top: 4px;
    padding-top: 12px;
    border-top: 1px solid #eceff4;
  }
  .client-address-section .address-row {
    margin-left: -6px;
    margin-right: -6px;
  }
  .client-address-section .address-row > [class*='col-'] {
    padding-left: 6px;
    padding-right: 6px;
  }
  .client-address-section .form-group {
    margin-bottom: 10px;
  }
  .client-address-section .form-control {
    height: 38px;
    padding: 6px 10px;
    font-size: 13px;
  }
  .invoice-address-section {
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eceff4;
  }
  .invoice-address-section .address-row {
    margin-left: -6px;
    margin-right: -6px;
  }
  .invoice-address-section .address-row > [class*='col-'] {
    padding-left: 6px;
    padding-right: 6px;
  }
  .invoice-address-section .form-group {
    margin-bottom: 10px;
  }
  .invoice-address-section .form-control {
    height: 38px;
    padding: 6px 10px;
    font-size: 13px;
  }
  .totals-container {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .total-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 340px;
    font-size: 18px;
    margin-bottom: 5px;
  }

  .total-row .label {
    font-weight: 500;
    color: #25396F;
  }

  .total-row .value {
    font-weight: 600;
    color: #25396F;
  }

  .total-final .label {
    font-size: 18px;
    font-weight: bold;
  }

  .total-final .value {
    font-size: 18px;
    font-weight: bold;
  }
  .v-select-wrapper {
  position: relative;
}
td {
  position: relative;
}
.v-select-loader-product {
  position: absolute;
  right: 55px;
  top: 34%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
.v-select-loader {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.table thead tr > th {
  font-size: 14px;
}
  </style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Invoice/InvoiceForm.vue